import { Icon } from 'lucide-react'

import { type CustomLucideIconProps } from './props'

export function SolidAlertCircleIcon ({ color = 'currentColor', ...props }: CustomLucideIconProps) {
  return (
    <Icon {...props} fill={color} stroke='none' iconNode={[]}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7ZM11 16C11 15.4477 11.4477 15 12 15H12.01C12.5623 15 13.01 15.4477 13.01 16C13.01 16.5523 12.5623 17 12.01 17H12C11.4477 17 11 16.5523 11 16Z'
      />
    </Icon>
  )
}
